export default __webpack_public_path__ + "static/media/crossroads14.73010d97.webp";